import { useEffect, useState } from "react";
import { getAllUserApi } from "../api/user.js";
export function useAllUsers() {
    const [allUsers, setAllUsers] = useState();
    const token = window.localStorage.getItem("token");

    useEffect(() => {
        if (token) {
            getAllUsers();
        }
    }, [token]);

    const getAllUsers = async () => {
        const response = await getAllUserApi();
        if (response?.data) {
            setAllUsers(response.data);
        } else {
            setAllUsers("Token Expired");
        }
    };

    return allUsers;
}
